import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropdownComponent } from '@macs-frontend/web-macs/shared';

@Component({
  selector: 'md-add-button',
  templateUrl: 'add-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddButtonComponent),
      multi: true,
    },
  ],
})
export class AddButtonComponent extends DropdownComponent {
  // @ts-expect-error
  @Input() active: boolean;
  // @ts-expect-error
  @Input() itemName: string;
  @Output() toggleActive: EventEmitter<any> = new EventEmitter<any>();

  // @ts-expect-error
  @ViewChild('input') inputElem: ElementRef<HTMLInputElement>;

  handleButtonClick() {
    this.toggleActive.emit();
  }

  selectValue(option: any): void {
    this.valueChange.emit(option);
    this.model = '';
    this.inputElem.nativeElement.focus();
  }

  canAddNew() {
    return (
      this.canAdd &&
      this.inputElem?.nativeElement.value &&
      !this.options.some(
        option => this.getOptionLabel(option) === this.inputElem.nativeElement.value,
      )
    );
  }
}
